import React from 'react'
import PropTypes from 'prop-types';
import moment from 'moment';

import { Button, ButtonGroup } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { TextInput, LabelGroup, Section, Tags, InsetSection, JsonEditorDialog, Text, Flex, YesNoDialog } from '~/views';
import { NetworkSelector } from '~/editors/network'

import style from './style.css'

export default class DeviceEditor extends React.Component {

  static propTypes = {
    device : PropTypes.object,
    networks : PropTypes.object,
    currentTags : PropTypes.object,
    onChange : PropTypes.func.isRequired,
    showHeader : PropTypes.bool
  }

  static defaultProps = {
    showHeader : true
  }

  constructor( props ) {
    super( props )
    this.state = { showDialog : false, showPrompt : false }
  }

  changePath( path, value, err ) {
    if ( err ) {
      console.log( `error setting ${key} to ${value}` );
      return;
    }
    this.props.onChange( { target : this.props.device, path, value } );
  }

  onExtra = ( newValue ) => {
    console.log( newValue )
  }

  onChangeNetwork = ( network ) => {
    const { device } = this.props
    if ( device == null || device.networkId == ( network && network.id ) ) {
      return
    }
    this.setState( { showPrompt : true, networkChange : network } )
  }

  onPromptRemoveYes = () => {
    const { networkChange } = this.state
    this.changePath( 'networkId', networkChange == null ? null : networkChange.id, false )
    this.setState( { showPrompt : false, networkChange : null } )
  }

  onPromptRemoveNo = () => {
    this.setState( { showPrompt : false, networkChange : null } )
  }

  render() {
    const { showPrompt, showDialog, networkChange } = this.state
    const { device, networks, showHeader } = this.props
    if ( device == null ) {
      return <div />
    }

    let simId, systemId, provisionId, connection;
    const isOrg = device.purpose === 'organization'
    const simulated = device.simNetworkId != null
    if ( device.simulatorId ) {
      simId = (
        <div className={style.identifier}>
          <b>Sim Id:</b>
          {device.simulatorId}
        </div>
      )
    }
    if ( device.systemId ) {
      systemId = (
        <div className={style.identifier}>
          <b>System Id:</b>
          {device.systemId}
        </div>
      )
    }
    if ( device.aliases && device.aliases.iothub ) {
      provisionId = (
        <div className={style.identifier}>
          <b>Iothub Id:</b>
          {device.aliases.iothub}
        </div>
      )
    }
    if ( device.iothubConnection ) {
      connection = (
        <div className={style.identifier}>
          <b>IotHub Connection:</b>
          {device.iothubConnection}
        </div>
      )
    }
    let metadata
    if ( device.metadata ) {
      metadata = JSON.stringify( device.metadata, null, 2 )
    }
    const nid = device.networkId
    const snid = device.simNetworkId
    const sid = snid && device.networkAliases && device.networkAliases[snid] && device.networkAliases[snid].id
    const networkData = device.networkData
    const network = nid && networks && networks.index[nid]
    let netAliasKeys = []
    if ( network && network.aliasKeys && Array.isArray( network.aliasKeys ) ) {
      netAliasKeys = network.aliasKeys
    } else if ( network && network.aliasKeys && ( ( network.aliasKeys instanceof String ) || ( typeof network.aliasKeys === 'string' ) ) ) {
      netAliasKeys = network.aliasKeys.split( ',' ).map( ( k ) => { return k.trim() } )
    }
    const netAliases = ( device.networkAliases && device.networkAliases[nid] ) || {}
    let cnData = null
    if ( networkData && nid && networkData[nid] ) { 
      cnData = (
        <div>
          { Object.keys( networkData[nid] ).map( ( key ) => {
            return (
              <div key={key} className={style.identifier}>
                <b>
                  {key}
                  :
                </b>
                {networkData[nid][key]}
              </div>
            )
          } )}
        </div>
      )
    }

    return (
      <Section title={showHeader ? device.name : null}>
        <Flex variant="vSpace" direction="column" align="stretch">
          <LabelGroup>
            <label>ID</label>
            <Text type="dim" text={device.id} />
          </LabelGroup> 
          <LabelGroup>
            <label>Name</label>
            <TextInput hint="Name..."
              value={device.name} 
              changeOnReturn 
              onChange={( v, err ) => { this.changePath( 'name', v, err ) }} />
          </LabelGroup>

          <LabelGroup>
            <label>Description</label>
            <TextInput hint="Description..."
              value={device.desc}
              changeOnReturn 
              onChange={( v, err ) => { this.changePath( 'desc', v, err ) }} />
          </LabelGroup>
          <LabelGroup>
            <label>Msg Route</label>
            <TextInput
              hint="Message Route Id..."
              value={device.messageRouteId} 
              validate={aliasValidator}
              changeOnReturn 
              onChange={( v, err ) => { this.changePath( 'messageRouteId', v, err ) }} />
          </LabelGroup>
          {
            device.messageRouteId ? 
              (
                <LabelGroup>
                  <label />
                  <Link to={`/project/${device.projectId}/messageRoute/${device.messageRouteId}`}>
                    view message route 
                    {' '}
                    <i className="fa fa-arrow-right" />
                  </Link>
                </LabelGroup>
              ) :
              null
          }
          <LabelGroup>
            <label>Tags</label>
            <Tags tags={device.tags}
              autofocus={false}
              suggestions={this.props.currentTags}
              tagAdded={( tag, arr ) => { this.changePath( 'tags', arr, false ) }}
              tagRemoved={( tag, arr ) => { this.changePath( 'tags', arr, false ) }} />
          </LabelGroup>
          <LabelGroup>
            <label>Network</label>
            <NetworkSelector networks={networks} current={nid} onSelect={this.onChangeNetwork} />
          </LabelGroup>
          {
            network == null || nid == null ? null :
              (
                <InsetSection style={{ width : '100%' }}>
                  {
                    netAliasKeys.map( ( key ) => {
                      return ( 
                        <LabelGroup key={key}>
                          <label>{key}</label>
                          <TextInput value={netAliases[key]} 
                            changeOnReturn 
                            onChange={( v, err ) => { this.changePath( `networkAliases/${nid}/${key}`, v, err ) }} />
                        </LabelGroup>
                      )
                    } )
                  }
                  {cnData}
                </InsetSection>
              )
          }
          <LabelGroup>
            <label>Simulator</label>
            <ButtonGroup className="pull-right">
              <Button bsStyle={simulated === true ? 'primary' : 'default'} onClick={() => this.changePath( 'simNetworkId', 'imagine', null )}>On</Button>
              <Button bsStyle={simulated === false ? 'primary' : 'default'} onClick={() => this.changePath( 'simNetworkId', null, null )}>Off</Button>
            </ButtonGroup>
          </LabelGroup>
          {
            sid == null || isOrg ? null : 
              (
                <InsetSection style={{ width : '100%' }}>
                  <div className={style.identifier}>
                    <b>Sim Id:</b>
                    {sid}
                  </div>
                </InsetSection>
              )

          }

          { false && (
            <LabelGroup>
              <label>External UID</label>
              <TextInput hint=""
                value={device && device.aliases && device.aliases.uuid} 
                acceptKey={keyValidator}
                changeOnReturn 
                onChange={( v, err ) => { this.changePath( 'aliases/uuid', v, err ) }} />
            </LabelGroup>
          )}

          <LabelGroup vertical>
            <label>Metadata</label>
            <InsetSection style={{ width : '100%' }}>
              <div className={metadata ? style.metadata : style.noMetadata}>{metadata || 'No metadata' }</div> 
              <Button style={{ float : 'right' }} bsSize="sm" onClick={() => { this.setState( { showDialog : true } ) }}>Edit</Button>
            </InsetSection>
          </LabelGroup>
          <LabelGroup vertical>
            <label>Identifiers</label>

            <InsetSection>
              {simId}
              {systemId}
              {provisionId}
              {connection}
            </InsetSection>
          </LabelGroup>
          <div className={style.identifier}>{`Created ${moment( device.created ).format( 'lll' )}` }</div>
        </Flex>
        <JsonEditorDialog 
          title="Device Metadata"
          message="Enter the JSON object for the metadata"
          show={showDialog} 
          onOk={( val ) => { 
            device.metadata = val; 
            this.changePath( 'metadata', val, false )
            this.setState( { showDialog : false } ) 
          }}
          onCancel={() => { this.setState( { showDialog : false } ) }}
          value={device.metadata} />

        <YesNoDialog show={showPrompt} 
          title={networkChange ? `Change network to ${networkChange.name}?` : 'Remove Network?'}
          message={<div>Are you sure you want to change this device's network. It will lose all identifiers associated with the current network?</div>}
          onYes={this.onPromptRemoveYes}
          onNo={this.onPromptRemoveNo} />
      </Section>
    ) 
  }
}

function aliasValidator( value ) {
  if ( value.length > 500 || !/^[a-zA-Z0-9_\-]+$/.test( value ) ) {
    return false
  }

  return true;
}

function keyValidator( evt ) {
  const inp = String.fromCharCode( evt.charCode );
  const c = evt.charCode;
  if ( /[a-zA-Z0-9_\-:]/.test( inp ) ) {
    return true;
  }
  return false;
}
